const locValidator = (value) => {
  if (!value) return "validate.loc_empty";
  const regex =
    /^\d+\s+\d+\s+\d+\s+[NS]\s+\d+\s+\d+\s+\d+\s+[EW]\s+\d+m\s+\d+m\s+\d+m$/;
  return regex.test(value) ? true : "validate.loc_failed";
};

export { locValidator };
